import { api } from './api';

export class GupShupService {
  async getTemplates() {
    return api.get('providers/gupshup/templates');
  }
}

export const gupShupService = new GupShupService();
